/**
 * eCo OCI에서 iframe으로 포탈을 띄울 때는 항상 onceLogin(`/login/:uuid`)으로 진입한다.
 * 이 진입점에서 세션 플래그를 세워두고, 앱 전역에서 "임베드 세션" 여부를 판별한다.
 *
 * - sessionStorage 사용 이유: 결제(Inicis/PayPal) 리다이렉트로 iframe이 풀 리로드되어도
 *   같은 브라우징 컨텍스트(같은 origin) 안에서는 유지되기 때문.
 * - 직접 접속 사용자는 각자 탭에 플래그가 없으므로 자연스럽게 분기가 갈린다.
 */
const EMBEDDED_KEY = "cp_embedded";

/** onceLogin 진입 시 1회 호출 */
export const markEmbeddedSession = () => {
  sessionStorage.setItem(EMBEDDED_KEY, "1");
};

/** 임베드(iframe) 세션 판별. onceLogin 플래그 우선, iframe 중첩은 보조 안전망. */
export const isEmbeddedSession = () =>
  sessionStorage.getItem(EMBEDDED_KEY) === "1" || window.self !== window.top;
